<div fxLayout="row wrap" class="header m-b-10">
    <div fxFlex="92" fxLayoutAlign="center center">
        <span class="header-text">Show Hide Queues</span>
    </div>
    <div class="pointer" (click)="onClose()">
        <mat-icon>clear</mat-icon>
    </div>
</div>
<div fxLayout="row wrap" class="list">
    <div *ngIf="queues.length">
        <div fxLayout="row wrap">
            <mat-checkbox [(ngModel)]="allItemSelected" (change)="onSelectAllItems($event)" class="all-item-checkbox">
                <b>All queues</b>
            </mat-checkbox>
        </div>
        <div fxLayout="row wrap" *ngFor="let item of queues; let i=index;" [matTooltip]="item.queueName">
            <mat-checkbox [checked]="!item.hidden" (change)="onQueueChecked(item, i)" class="list-item">
                {{item.queueName}}
            </mat-checkbox>
        </div>
    </div>
    <div *ngIf="!queues.length" class="msg">
        No queues available
    </div>
</div>